// ----------------------------------------------------------------------

export default function LoadingButton() {
  return {
    MuiLoadingButton: {
      defaultProps: {
        size: 'small',
        color: 'secondary',
      },
      styleOverrides: {
        sizeSmall: {
          paddingTop: '7.43px',
          paddingBottom: '7.43px',
        },
        root: {
          '&.MuiButton-text': {
            '& .MuiLoadingButton-startIconPendingStart': {
              marginLeft: 0,
            },
            '& .MuiLoadingButton-endIconPendingEnd': {
              marginRight: 0,
            },
          },
        },
      },
    },
  };
}
